module.exports = ".player-adjustment-caption {\r\n  display: contents;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/member-billing-info/player-discount/player-discount.component.css
// module id = ./src/app/shared/components/member-billing-info/player-discount/player-discount.component.css
// module chunks = main